import * as actionType from './types';
import axios from '../../../common/config/axios';

export const claimAngpau = (props) => (dispatch) =>
{
    axios.post('angpau_bonus/claim', props)
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.CLAIM_ANGPAU,
            value: response.data
        });
    })
    .catch(err => 
    {
      
    });
};

export const mobileAppsClaim = (data) => dispatch => {
    axios.post('mobile_apps_promo/claim', data).then( (response) => {
      dispatch ({
          type: actionType.MOBILE_APPS_PROMO_CLAIM,
          value: response.data
      })
    }).catch (err => {
      console.log(err);
    })
  };